<template>
  <b-modal
    v-if="isAlertOpen"
    v-model="isAlertOpen"
    has-modal-card
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-label="Update All Services"
    aria-modal
    v-bind="$attrs"
    @close="isAlertOpen = false"
  >
    <div class="alert_modal__container">
      <h3 class="title is-4 has-text-weight-semibold">
        <span class="icon is-small">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        Update All Services
      </h3>
      <p
        class="subtitle is-6 has-text-weight-light mt-4 text-center"
        style="width: 30rem; margin: 0 auto"
      >
        <strong>All services sales </strong> will be updated to the latest
        version, which may take some time. This action cannot be undone.
      </p>
      <div class="is-flex is-justify-content-center mt-4" style="gap: 1rem">
        <BaseButton action="secondary" @click="onCancel">
          <p slot="text">No, cancel</p>
        </BaseButton>
        <BaseButton action="tercery" @click="onConfirm(quoteServices)">
          <p slot="text">Yes, continue</p>
        </BaseButton>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "UpdateAllServices",
  props: {
    isUpdateAllServicesAlertOpen: {
      type: Boolean,
      default: false,
    },
    onCancel: {
      type: Function,
      default: () => {},
    },
    onConfirm: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      quoteServices: "itinerary/getServicesItinerary",
    }),
  },
  watch: {
    isAlertOpen(newValue) {
      if (this.isUpdateAllServicesAlertOpen === newValue) return;
      this.$emit("update:isUpdateAllServicesAlertOpen", newValue);
    },
    isUpdateAllServicesAlertOpen(newValue) {
      this.isAlertOpen = newValue;
      this.$store.dispatch("utils/setIsModalOpen", newValue);
    },
  },
  data() {
    return {
      isAlertOpen: this.isUpdateAllServicesAlertOpen,
    };
  },
};
</script>

<style>
.alert_modal__container {
  padding: 1.5rem;
  text-align: center;
  width: 100%;
  background-color: #fff;
  border-radius: 1rem;
}
</style>
